import React from "react"
import autobind from "class-autobind"
import moment from "moment"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, CircularProgress } from "material-ui"
import Table from "../../../../components/common/Table"
import strings from "../../../../localization/strings"
import { IWorkforceAssessmentDashboardHierarchySummary } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"
import { IWorkforceAssessmentDashboardJobSummary } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"
import * as utils from "../../../../helpers/utils"
import numeral from "numeral"
import HierarchySettingsStore from "../../../../stores/HierarchySettingsStore"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IState{}

interface IProps {
    hierarchyItems: IWorkforceAssessmentDashboardHierarchySummary[]
    jobItems: IWorkforceAssessmentDashboardJobSummary[]
    onHierarchyRowClick: any
    onJobRowClick: any
}

export default class WorkforceAssessmentHierarchyJobTable extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {

        if(HierarchySettingsStore.getCanSelectedHaveChildren()){        
            return (
                <Table items={this.props.hierarchyItems} readonly>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderColumn style={{ width: 250, }}>
                                {strings.Name}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 75, }}>
                                {strings.Utilization}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 75, }}>
                                Overtime
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50, }}>
                                {strings.FillRate}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Core
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Float
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Per Diem
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Agency
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 75, textAlign: "center" }} >
                            Potential<br />Savings
                            </TableHeaderColumn>                        
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover={true} deselectOnClickaway={false}>
                        {this.props.hierarchyItems.map((row, i) =>
                            <TableRow key={row.HierarchyId}>
                                <TableRowColumn style={{ width: 250 }}>
                                    {row.HierarchyName}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 75 }}> 
                                    {utils.toPercentage(row.ScheduleBudgetInfo.FTEUtilizationInfo.Utilization)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 75 }}> 
                                    {utils.toPercentage(row.ScheduleBudgetInfo.OvertimeInfo.OvertimePercentageOfWhole)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.FillRateInfo.FillRate)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Core)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Float)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.PerDiem)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Agency)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 75 }}>
                                    <div style={{cursor: "pointer"}} onClick={()=>{
                                        this.props.onHierarchyRowClick(row)                                    
                                    }}>
                                        {numeral(row.ScheduleBudgetInfo.SavingsPotential.TotalSavings).format('$0.0a')} 
                                        <i className="fa fa-info-circle" style={{fontSize: 15, marginLeft: 5, }} />
                                    </div>
                                </TableRowColumn>

                            </TableRow>
                        )}
                    </TableBody>                
                </Table>
            )
        }else{
            return (
                <Table items={this.props.jobItems} readonly>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderColumn style={{ width: 250, }}>
                                {strings.Name}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 75, }}>
                                {strings.Utilization}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50, }}>
                                {strings.FillRate}
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Core
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Float
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Per Diem
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 50 }} >
                                Agency
                            </TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 75, textAlign: "center" }} >
                            Potential<br />Savings
                            </TableHeaderColumn>                        
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover={true} deselectOnClickaway={false}>
                        {this.props.jobItems.map((row, i) =>
                            <TableRow key={row.JobId}>
                                <TableRowColumn style={{ width: 250 }}>
                                    {row.JobName}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 75 }}> 
                                    {utils.toPercentage(row.ScheduleBudgetInfo.FTEUtilizationInfo.Utilization)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.FillRateInfo.FillRate)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Core)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Float)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.PerDiem)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 50 }}>
                                    {utils.toPercentage(row.ScheduleBudgetInfo.WorkTypeInfo.Agency)}
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 75 }}>
                                    <div style={{cursor: "pointer"}} onClick={()=>{
                                        this.props.onJobRowClick(row)                                    
                                    }}>
                                        {numeral(row.ScheduleBudgetInfo.SavingsPotential.TotalSavings).format('$0.0a')} 
                                        <i className="fa fa-info-circle" style={{fontSize: 15, marginLeft: 5, }} />
                                    </div>
                                </TableRowColumn>

                            </TableRow>
                        )}
                    </TableBody>                
                </Table>
            )
        }
    }
}